import React from 'react';
import { connect } from 'react-redux';
import {
  getSharerViewers,
  revokeViewer
} from '../../redux/overview/overviewActions';
import ViewerLine from '../../components/Share/ShareModal/ViewerLine';
import { getVrrPreferences } from '../../redux/settings/settingAction';
import { TViewerLine } from './types';

export const ViewerLineC: React.FC<TViewerLine> = ({
  currentAccountId,
  viewers,
  revoke
}: TViewerLine) => {
  return (
    <>
      {viewers?.map((viewer) => (
        <ViewerLine
          accountId={currentAccountId}
          username={viewer.username}
          email={viewer.email}
          key={viewer.username}
          onClick={revoke}
        />
      ))}
    </>
  );
};

const mapStateToProps = (state: any) => ({
  currentAccountId: getVrrPreferences(state)?.current_account_id,
  viewers: getSharerViewers(state)
});

const mapDispatchToProps = (dispatch: any) => ({
  revoke: (email: string, accountId: string | undefined) =>
    dispatch(revokeViewer({ email, accountId }))
});

const ViewerLineContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ViewerLineC);

export default ViewerLineContainer;
